<template>
  <section class="hero">
    <div class="container">
      <div class="hero-content">
        <div class="hero-text">
          <div class="tagline">
            AI驱动的硬件设计平台
          </div>
          <h1>重新定义硬件设计</h1>
          <p>
            DesignPulse利用先进AI技术彻底变革硬件设计流程，将设计周期缩短90%，成本降低85%，赋能每一位创新者实现硬件创意
          </p>
          <div class="hero-buttons">
            <button
              class="btn btn-primary"
              @click="handleDemo"
            >
              <i class="fas fa-bolt" /> 立即开始设计
            </button>
            <button
              class="btn btn-outline"
              @click="handleDemo"
            >
              <i class="fas fa-play-circle" /> 观看演示
            </button>
          </div>
          <div class="stats">
            <div class="stat-item">
              <div class="stat-value">
                -90%
              </div>
              <div class="stat-label">
                设计周期缩短
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-value">
                -85%
              </div>
              <div class="stat-label">
                开发成本降低
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-value">
                ¥0
              </div>
              <div class="stat-label">
                入门成本
              </div>
            </div>
          </div>
        </div>
        <div class="hero-image">
          <img
            src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=800&q=80"
            alt="DesignPulse Platform"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import localStorageTools from "@/utils/localStorageTool";

const handleDemo = () => {
  // ✅ 检查登录状态
  const logToken = localStorageTools.getValueWithExpiry("logToken");
  if (!logToken) {
    // 未登录，先跳转登录，登录后进入系统
    window.location.href = "/login.html?redirect=%2Fmain";
  } else {
    // 已登录，直接跳转
    window.location.href = "/main/";
  }
};

const handleConsult = () => {
  // 打开咨询表单或联系表单
};
</script>

<style scoped>
.hero {
  padding: 180px 0 120px;
  background: url("https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")
    no-repeat center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--secondary);
  opacity: 0.85;
}

.hero-content {
  display: flex;
  gap: 80px;
  align-items: center;
  position: relative;
  z-index: 2;
}

.hero-text {
  flex: 1;
  color: white;
}

.hero-image {
  flex: 1;
  position: relative;
  animation: float 8s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

.hero-image img {
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 30px 50px rgba(0, 0, 0, 0.3);
}

.tagline {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  padding: 8px 20px;
  border-radius: 50px;
  display: inline-block;
  margin-bottom: 25px;
  font-weight: 600;
  font-size: 1.1rem;
  backdrop-filter: blur(5px);
}

h1 {
  font-size: 3.5rem;
  line-height: 1.2;
  margin-bottom: 25px;
  color: white;
  font-weight: 800;
}

.hero p {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 45px;
  max-width: 90%;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 50px;
}

.stats {
  display: flex;
  gap: 50px;
  margin-top: 30px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 30px;
}

.stat-item:before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  height: 30px;
  width: 4px;
  background: var(--gray-500);
  border-radius: 2px;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 800;
  color: white;
  line-height: 1;
}

.stat-label {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 5px;
}

.btn-primary {
  background: var(--gray-600); /* 主按钮灰色 */
}
</style>
